// import Close from "@mui/icons-material/Close";
// import FadeIn from "react-fade-in/lib/FadeIn";
// import * as React from "react";

// const Modal = (props) => {
//   const { icon, title, closeEvent, bgColour } = props;
//   return (
//     <div
//       className="absolute   !z-[10]"
//       aria-labelledby="modal-title"
//       role="dialog"
//       aria-modal="true"
//     >
//       <div className="fixed inset-0 !z-[10] bg-[#00000040]  dark:bg-[#ffffff90] backdrop-blur-sm "></div>
//       <div className="fixed inset-0 !z-[10]  overflow-y-auto">
//         <div
//           onClick={() => closeEvent()}
//           className="flex min-h-full w-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
//         >
//           <FadeIn>
//             <div
//               onClick={(e) => e.stopPropagation()}
//               className="relative bg-[#FFFFFF] animate transition-transform transform overflow-hidden  rounded-lg text-left shadow-xl   min-w-[400px] min-h-[200px]"
//             >
//               {title && (
//                 <div
//                   className={`p-3 flex justify-between ${
//                     bgColour ?? "bg-[#FFFFFF]"
//                   }`}
//                 >
//                   <span className="flex">
//                     <div className="pr-1 mr-2 mt-2 text-primary">
//                       {icon ? icon : ""}
//                     </div>
//                     <div className="pt-[3px]  text-[20px] font-semibold">
//                       {title}
//                     </div>
//                   </span>
//                   {closeEvent && (
//                     <span
//                       onClick={() => closeEvent()}
//                       className="cursor-pointer pr-0.5"
//                     >
//                       <Close />
//                     </span>
//                   )}
//                 </div>
//               )}
//               <div className={` ${bgColour ?? "bg-[#FFFFFF] p-4"}`}>
//                 {props.children}
//               </div>
//             </div>
//           </FadeIn>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default Modal;

import Close from "@mui/icons-material/Close";
import FadeIn from "react-fade-in/lib/FadeIn";
import * as React from "react";

const Modal = (props) => {
  const {
    icon,
    title,
    closeEvent,
    bgColour,
    children,
    width,
    height,
    className,
    bodyClassName,
    hideClose = false,
  } = props;

  return (
    <div
      className="absolute !z-[10]"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Backdrop */}
      <div className="fixed inset-0 !z-[10] bg-[#00000040] dark:bg-[#ffffff90] backdrop-blur-sm" />

      {/* Modal Wrapper */}
      <div className="fixed inset-0 !z-[10] overflow-y-auto overflow-x-hidden">
        <div
          onClick={() => closeEvent?.()}
          className="flex min-h-full w-full items-center justify-center p-2 sm:p-4 text-center"
        >
          <FadeIn>
            {/* Modal Container */}
            <div
              onClick={(e) => e.stopPropagation()}
              className={`
                relative
                w-full
                min-w-0
                max-w-[95vw]
                sm:max-w-[90vw]
                md:max-w-[1800px]
                bg-white
                rounded-xl
                text-left
                shadow-xl
                overflow-hidden
                animate
                transition-transform
                transform
                ${width || ""}
                ${height || ""}
                ${className || ""}
              `}
            >
              {/* Header */}
              {title && (
                <div
                  className={`
                    px-3
                    sm:px-4
                    py-3
                    flex
                    items-center
                    justify-between
                    gap-3
                    border-[#E5E5E5]
                    ${bgColour || "bg-[#FFFFFF]"}
                  `}
                >
                  <div className="flex items-center gap-2 min-w-0 flex-1">
                    {icon && (
                      <div className="text-primary flex-shrink-0">{icon}</div>
                    )}

                    <div
                      id="modal-title"
                      className="text-base sm:text-lg md:text-xl font-semibold break-words truncate"
                    >
                      {title}
                    </div>
                  </div>

                  {!hideClose && closeEvent && (
                    <button
                      onClick={() => closeEvent()}
                      className="cursor-pointer flex items-center justify-center rounded-md p-1 hover:bg-[#F3F3F3] transition flex-shrink-0"
                    >
                      <Close />
                    </button>
                  )}
                </div>
              )}

              {/* Body */}
              <div
                className={`
                  bg-white
                  p-3
                  sm:p-4
                  md:p-5
                  w-full
                  min-w-0
                  max-w-full
                  max-h-[85vh]
                  overflow-y-auto
                  overflow-x-auto
                  break-words
                  ${bodyClassName || ""}
                  ${bgColour ? bgColour : ""}
                `}
              >
                {/* Content Wrapper */}
                <div className="w-full min-w-0">{children}</div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default Modal;
